/* eslint-disable react/jsx-indent-props */
/* eslint-disable  react/no-multi-comp */
/*  eslint-disable react/display-name */
/*  eslint-disable react/prop-types */

import React, { Fragment } from 'react';
import { isEmpty } from 'ramda';
import Status from './Status';
import CircleLogo from '../components/common/CircleLogo';
import MultiSelectFilter from './filters/MultiSelectFilter';
import ApplyFilter from './filters/ApplyFilter';
import { Button } from '@app/ui';
import { pending, processing } from '../constants/pacingStatus';

const buildHeaders = ({
    deleteGoal,
    setCurrentGoalId,
    filter,
    t,
    hasRhAttributionPermission,
}) => {
    return [
        {
            Header: t('pacing.table.columns.goalName'),
            accessor: 'name',
            Cell: row => (
                <div className="-vertical-align-text-container">
                    <span className="-vertical-align-text">{row.value}</span>
                </div>
            ),
            filterable: false,
        },
        {
            Header: t('pacing.table.columns.rightsholder'),
            accessor: 'rightsholderName',
            Cell: row => {
                const { rightsholderLogoUrl } = row.original;
                return (
                    <div>
                        <CircleLogo
                            url={rightsholderLogoUrl}
                            name={row.value}
                        />
                        <span className="-m-l-2">{row.value}</span>
                    </div>
                );
            },
            width: 150,
            Filter: () => (
                <MultiSelectFilter filter={filter} column="rightsholderIds" />
            ),
        },
        {
            Header: t('pacing.table.columns.sponsor'),
            accessor: 'sponsorName',
            Cell: row => {
                const { sponsorLogoUrl } = row.original;
                return (
                    <div>
                        <CircleLogo url={sponsorLogoUrl} name={row.value} />
                        <span className="-m-l-2">{row.value}</span>
                    </div>
                );
            },
            width: 150,
            Filter: () => (
                <MultiSelectFilter filter={filter} column="sponsorIds" />
            ),
        },
        {
            Header: t('pacing.table.columns.placement'),
            accessor: 'placementNames',
            Cell: row => {
                const rowContent = isEmpty(row.value)
                    ? t('pacing.table.values.allPlacements')
                    : row.value.join(', ');
                return (
                    <div className="-vertical-align-text-container">
                        <span className="-vertical-align-text">
                            {rowContent}
                        </span>
                    </div>
                );
            },
            width: 150,
            Filter: () => (
                <MultiSelectFilter
                    filter={filter}
                    column="rightsholderPlacementIds"
                />
            ),
        },
        {
            Header: t('pacing.table.columns.goal'),
            accessor: 'description',
            Cell: row => {
                const { label, value } = row.value;
                if (!label || !value) return null;
                return (
                    <div className="-vertical-align-text-container">
                        <span className="-vertical-align-text">
                            <span className="gds-text--bold">{value}</span>{' '}
                            {label}
                        </span>
                    </div>
                );
            },
            width: 150,
            Filter: () => (
                <MultiSelectFilter filter={filter} column="metricIds" />
            ),
        },
        {
            Header: t('pacing.table.columns.status'),
            accessor: 'statusId',
            Cell: row => {
                const { statusId, targetValue, currentValue } = row.original;
                return (
                    <div className="-vertical-align-text-container">
                        <span className="-vertical-align-text">
                            <Status
                                statusId={statusId}
                                targetValue={targetValue}
                                currentValue={currentValue}
                            />
                        </span>
                    </div>
                );
            },
            minWidth: 180,
            Filter: () => (
                <MultiSelectFilter filter={filter} column="statusIds" />
            ),
        },
        ...(hasRhAttributionPermission
            ? [
                  {
                      Header: t('pacing.table.columns.methodology'),
                      accessor: 'useRightsholderAttribution',
                      Cell: row => {
                          const methodValue =
                              row.original?.useRightsholderAttribution ===
                                  true || row.original?.isUsingRha === true
                                  ? t('pacing.table.values.leagueAttribution')
                                  : t('pacing.table.values.teamAttribution');

                          return (
                              <div className="-vertical-align-text-container">
                                  <span className="-vertical-align-text">
                                      {methodValue}
                                  </span>
                              </div>
                          );
                      },
                      width: 170,
                      filterable: false,
                  },
              ]
            : []),
        {
            Header: ' ',
            accessor: 'id',
            Cell: row => {
                const { id, statusId } = row.original;
                const disabled = [pending, processing].some(
                    status => status === statusId,
                );
                const onClick = () => {
                    setCurrentGoalId(id);
                };

                const archive = async () => {
                    const { id, name } = row.original;
                    const isConfirmed = confirm(
                        t('pacing.modals.delete.message', { name }),
                    );
                    if (!isConfirmed) return;
                    await deleteGoal(id);
                };
                return (
                    <Fragment>
                        <Button
                            variant="primary"
                            size="small"
                            onClick={onClick}
                            disabled={disabled}
                            className="-m-l-2 table-icon "
                        >
                            <i className="fa fas fa-eye" aria-hidden="true" />
                        </Button>
                        <Button
                            variant="danger"
                            size="small"
                            onClick={archive}
                            className="-m-l-2 table-icon"
                        >
                            <i
                                className="fa fas fa-trash-alt"
                                aria-hidden="true"
                            />
                        </Button>
                    </Fragment>
                );
            },
            Filter: <ApplyFilter filter={filter} />,
        },
    ];
};

export default buildHeaders;
